(() => {
  const root = document.querySelector('.cs-microbio-world');
  if (!root || root.dataset.worldReady) return;
  root.dataset.worldReady = 'true';
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const figures = root.querySelectorAll('[data-mb-breathe]');
  const setMotion = () => figures.forEach(el => el.classList.toggle('mb-breathe', !motion.matches && el.dataset.visible === 'true'));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => { entry.target.dataset.visible = String(entry.isIntersecting); });
      setMotion();
    });
    figures.forEach(el => observer.observe(el));
  }
  motion.addEventListener('change', setMotion);
})();
